import { render } from "./search-footer.vue?vue&type=template&id=3583f7ba"
import script from "./search-footer.js?vue&type=script&lang=js"
export * from "./search-footer.js?vue&type=script&lang=js"

import "./search-footer.vue?vue&type=style&index=0&id=3583f7ba&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__